function TeamController(){
	this.className	= "TeamController";
	this.glob		= "/team**";
	this.debug		= false;
};
TeamController.inheritsFrom( StandardController );
TeamController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
TeamController.prototype.on = function(){
  this.configElements();
};
TeamController.prototype.configElements = function() {

  // General selectors (not related to a specific parent)
  this.$editMemberListButton = $('.js-edit-member-list-button');
  this.$addMemberListButton = $('.js-add-member-list-button');
  this.$startTrainingBlock = $('.js-start-training-block');
  this.$startTrainingLink = $('.js-start-training-link');
  //this.$linksBlock = $('.js-links-block');
  this.$coursesCompletedBlock = $('.js-courses-completed-block');
  this.$coursesAvailableBlock = $('.js-courses-available-block');
  this.$editDetailsButton = $('.js-edit-details-button');
  this.$confirmButton = $('.js-confirm-button');
  this.$cancelButton = $('.js-cancel-button');
  this.$doneEditingBlock = $('.js-done-editing-block');
  this.$doneEditingButton = $('.js-done-editing-button');
  this.$formLabel = $('.js-form-label');
  this.$formItem = $('.js-form-item');
  this.$confirmCancelBlock = $('.js-confirm-cancel-block');
  this.$removeButton = $('.js-remove-button');


  // Buttons event handlers
  this.$addMemberListButton.on('click', Igloo.$d(this, function($this) {
    this.addMemberList();
  }));
  this.$editMemberListButton.on('click', Igloo.$d(this, function($this) {
    this.activateGeneralEditMode();
  }));
  this.$doneEditingButton.on('click', Igloo.$d(this, function($this) {
    this.deactivateGeneralEditMode();
  }));
  this.$editDetailsButton.on('click', Igloo.$d(this, function($this, event) {
    this.activateItemEditMode($(event.target))
  }));

  this.$confirmButton.click(Igloo.delegate(this,function(event) {
    var $currentTeamMember  = $(event.target).closest('.team-member');
    var staffId             = $currentTeamMember.attr("data-staff-id");
    var $formLabel          = $currentTeamMember.find('.js-form-label');
    var $formItem           = $currentTeamMember.find('.js-form-item');

    const firstName = $($formItem[0]).find('input').val();
    const lastName = $($formItem[1]).find('input').val();
    const jobTitle = $($formItem[2]).find('input').val();
    $formLabel[0].innerHTML = `${firstName} ${lastName}`;
    $formLabel[1].innerHTML = jobTitle;
    this.deactivateItemEditMode($(event.target));

    this.submitFromFormItemList(staffId,$formItem);
  }))


  this.$cancelButton.on('click', Igloo.delegate(this, function(event) {
    this.deactivateItemEditMode($(event.target));
  }));
  this.$removeButton.on('click', Igloo.delegate(this,this.removeButtonClicked));

  /*
   * Trigger popup for "Start Training" link
   */
  this.$startTrainingLink.on('click', Igloo.$d(this, function($this){
    const firstName = $this.attr('data-name');
    const courseLink = $this.attr('data-course-link');

    this.startTrainingPopup = new StartTrainingPopup({
      	name: firstName,
      	courseLink: courseLink,
		controller: this
    });
  }));
}
TeamController.prototype.removeButtonClicked = function(event) {
  var $currentTeamMember  = $(event.target).closest('.team-member');
  var staffId             = $currentTeamMember.attr("data-staff-id");

  this.ajax({
    staffId: staffId,
    action: "delete"
  });
  this.updateStaffCount(-1)

  $currentTeamMember.hide();
  //Don't like having this html in here, but quick win and it's late!
  $currentTeamMember.after(`<div class="cont-12 team-member left-sm-1"><p>Team member deleted. <a href="#" class="js-undo" data-staff-id="${staffId}">Undo?</a></p></div>`);

  var $undoBlock = $currentTeamMember.next();
  $undoBlock.click(e => {
    e.preventDefault();

    this.ajax({
      staffId: staffId,
      action: "recover"
    });

    $(e.currentTarget).remove();
    $currentTeamMember.show();
    this.updateStaffCount(1)

  });
  setTimeout(function(){
    if($undoBlock.length){
      console.log(1);
      $undoBlock.animate({opacity:0},{duration:5000,complete:e => { $undoBlock.remove(); }});
    }
  },5000);
};
TeamController.prototype.updateStaffCount = function(amount) {
  $(".js-staff-count").text(function(){
    return parseInt($(this).text()) + amount;
  })
}
TeamController.prototype.ajax = function(data) {
  return $.ajax({
    url: nav.getState().nextUrl,
    data: data,
    method: "post"
  }).then(e => {
    console.log(e);
	jcache.clearCache();
    return e;
  })
}

TeamController.prototype.submitFromFormItemList = function(staffId,$formItem) {
    let data = { staffId: staffId };
    $formItem.each(function(){
      const $item = $(this).find("input");
      data[$item.attr("name")] = $item.val();
    });

    if(staffId == "new") this.updateStaffCount(1);

    return this.ajax(data);
}
TeamController.prototype.addMemberList = function() {

  var controller = this;
  
  // Identify and clone the first team member.
  var firstTeamMember = $($('.team-member-reference')[0]);
  firstTeamMember.after(firstTeamMember.clone());

  // Identify the new team member, set children visibility and clean fields.
  var newTeamMember = $($('.team-member-reference')[1]);  
  var formLabel = newTeamMember.find('.js-form-label');
  var formItem = newTeamMember.find('.js-form-item');
  var confirmCancelBlock = newTeamMember.find('.js-confirm-cancel-block');
  var linksBlock = newTeamMember.find('.js-links-block');
  var fields = newTeamMember.find('input');
  var confirmButton = newTeamMember.find('.js-confirm-button');
  var $cancelButton = newTeamMember.find('.js-cancel-button');
  var $editDetailsButton = newTeamMember.find('.js-edit-details-button');
  var $removeButton = newTeamMember.find('.js-remove-button');
  var $coursesComplete = newTeamMember.find('.js-courses-completed');
  var $noMembersMessage = $('.js-no-members-message');

  $noMembersMessage.addClass('hide');

  newTeamMember.removeClass('team-member-reference');
  newTeamMember.removeClass('hide');
  newTeamMember.addClass('team-member');

  newTeamMember.attr("data-staff-id","");
  $coursesComplete.text("0");


  newTeamMember.addClass('js-team-member-new');

  formLabel.addClass('hide');
  formItem.removeClass('hide');
  confirmCancelBlock.removeClass('hide');
  linksBlock.addClass('hide');

  confirmButton.click(Igloo.delegate(this,function(event) {
    var $currentTeamMember  = $(event.target).closest('.team-member');
    $currentTeamMember.removeClass('js-team-member-new');

    const firstName = $(formItem[0]).find('input').val();
    const lastName = $(formItem[1]).find('input').val();
    const jobTitle = $(formItem[2]).find('input').val();
    formLabel[0].innerHTML = `${firstName} ${lastName}`;
    formLabel[1].innerHTML = jobTitle;

    this.deactivateItemEditMode($(event.target));
    this.submitFromFormItemList("new",formItem).then(e => {
      newTeamMember.attr("data-staff-id",e.staffId);
    });

  }))
  $cancelButton.on('click', Igloo.$delegate(this, function($this, event) {
    var currentTeamMember = $this.closest('.team-member');
    currentTeamMember.remove();
    if (!$('.team-member').length) $('.js-no-members-message').removeClass('hide');
  }));
  $editDetailsButton.on('click', Igloo.$d(this, function(event) {
    this.activateItemEditMode($(event.target))
  }));
  $removeButton.on('click', Igloo.$d(this, function(event) {
    this.activateItemEditMode($(event.target))
  }));
  $removeButton.on('click', Igloo.delegate(this,this.removeButtonClicked));


  fields.each(function() {
    this.value = '';
  })

  fields[0].focus();
}

TeamController.prototype.activateGeneralEditMode = function() {
  var startTrainingBlock = $('.js-start-training-block');
  var linksBlock = $('.js-links-block');
  this.$editMemberListButton.addClass('hide');
  this.$addMemberListButton.removeClass('hide');
  this.$coursesCompletedBlock.addClass('hide');
  this.$coursesAvailableBlock.addClass('hide');
  this.$doneEditingBlock.removeClass('hide');
  startTrainingBlock.addClass('hide');
  linksBlock.removeClass('hide');
}

TeamController.prototype.deactivateGeneralEditMode = function() {
  var teamMemberNew = $('.js-team-member-new');
  var linksBlock = $('.js-links-block');
  var startTrainingBlock = $('.js-start-training-block');
  var confirmCancelBlock = $('.js-confirm-cancel-block');
  var formLabel = $('.js-form-label');
  var formItem = $('.js-form-item');

  teamMemberNew.remove();

  this.$editMemberListButton.removeClass('hide');
  this.$addMemberListButton.addClass('hide');
  this.$coursesCompletedBlock.removeClass('hide');
  this.$coursesAvailableBlock.removeClass('hide');
  this.$doneEditingBlock.addClass('hide');
  
  formLabel.removeClass('hide');
  formItem.addClass('hide');
  startTrainingBlock.removeClass('hide');
  linksBlock.addClass('hide');
  confirmCancelBlock.addClass('hide');
}

TeamController.prototype.activateItemEditMode = function(target) {
  var teamMember = target.closest('.team-member');
  console.log(teamMember);
  var formLabel = teamMember.find('.js-form-label');
  var formItem = teamMember.find('.js-form-item');
  var confirmCancelBlock = teamMember.find('.js-confirm-cancel-block');
  var linksBlock = teamMember.find('.js-links-block');
  formLabel.addClass('hide');
  formItem.removeClass('hide');
  confirmCancelBlock.removeClass('hide');
  linksBlock.addClass('hide');
}

TeamController.prototype.deactivateItemEditMode = function(target) {
  var teamMember = target.closest('.team-member');
  var formLabel = teamMember.find('.js-form-label');
  var formItem = teamMember.find('.js-form-item');
  var confirmCancelBlock = teamMember.find('.js-confirm-cancel-block');
  var linksBlock = teamMember.find('.js-links-block');
  formLabel.removeClass('hide');
  formItem.addClass('hide');
  confirmCancelBlock.addClass('hide');
  linksBlock.removeClass('hide');
}

TeamController.prototype.off = function(){
  if(this.startTrainingPopup) this.startTrainingPopup.destroy();
};